export interface SheetFrame {
  width: number
  height: number
  top: number
}

const BACK_SIZES = [
  { width: 100, height: 100 },
  { width: 84, height: 90 },
]

export interface PracticeStackLayout {
  front: SheetFrame
  // Drawn back to front.
  backs: SheetFrame[]
}

export function practiceStackLayout(
  practiceCount: number,
): PracticeStackLayout {
  const count = Math.min(Math.max(practiceCount, 1), 3)
  const frontTop = 8 + 6 * (count - 1)
  const backs: SheetFrame[] = []
  for (let i = count - 1; i >= 1; i--) {
    backs.push({ ...BACK_SIZES[i - 1], top: frontTop - 6 * i })
  }
  return { front: { width: 108, height: 116 - frontTop, top: frontTop }, backs }
}
